import _ from 'lodash';
import React from 'react';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as importCsvSettings from './importCsvSettings';
import * as types from './types';



const ImportCsvModalComponent = ImportCsvModal.genComponent<types.NetSuiteShipItemsPropertyName>();

export interface IProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [importNetSuitePaymentMethods, importNetSuitePaymentMethodsTuple] = dataService.useImportNetSuitePaymentMethods();

  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      importNetSuitePaymentMethods(rows);
    },
    [importNetSuitePaymentMethods]
  );

  const loading = importNetSuitePaymentMethodsTuple.loading;

  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={loading}
      title="Import Net Suite Payment Methods"
      columnDescriptions={importCsvSettings.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={props.onAccept} />
  );
};
